import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ZodSubmitLeaveCorrectionInput } from '@functieloonhuis/shared';
import { verlofApi } from '../../../lib/verlofApi';
import { leaveKeys } from './useMijnVerlof';

/**
 * Story 2.4: urencorrectie indienen. Anders dan `useSubmitLeaveRequest`
 * (waar de goedkeuringslijst alleen ongeldig wordt bij een namens-aanvraag)
 * geldt hier ALTIJD dat er iets voor een beoordelaar verschijnt — een
 * correctie is per definitie `in_afwachting` totdat iemand hem beoordeelt
 * (Story 2.6), ook wanneer de indiener zelf de aanvrager is.
 */
export function useSubmitLeaveCorrection() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: number; input: ZodSubmitLeaveCorrectionInput }) =>
      verlofApi.submitCorrection(id, input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: leaveKeys.mine() });
      queryClient.invalidateQueries({ queryKey: ['leave-requests', 'approval-queue'] });
    },
  });
}
